import { LoginHomePage } from '@pages/auth/login-home/login-home';

export function loginHomeFactory(): any {
    return LoginHomePage;
}
